import { render, staticRenderFns } from "./anti-fake.vue?vue&type=template&id=c616f736&scoped=true&"
import script from "./anti-fake.vue?vue&type=script&lang=js&"
export * from "./anti-fake.vue?vue&type=script&lang=js&"
import style0 from "./anti-fake.vue?vue&type=style&index=0&id=c616f736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c616f736",
  null
  
)

export default component.exports